import React from 'react';
import PropTypes from 'prop-types';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import {
  PremiumSectionSeparator,
  Section,
  SectionDetails,
  SectionSummary,
  SectionSummaryDescription,
  SectionSummaryTitle,
} from './styles';
import LinkedIn from './social-links-components/linkedin';
import Twitter from './social-links-components/twitter';

export default function SocialLinks({ linkedinUrl, twitterUrl, onUpdate }) {
  const [links, setLinks] = React.useState({ linkedin: linkedinUrl, twitter: twitterUrl });

  useChangeAwareEffect(({ did }) => {
    did.links.change && onUpdate({ profileLinks: links });
  }, { links, onUpdate });

  return (
    <>
      <PremiumSectionSeparator />
      <Section className="form-group">
        <SectionSummary>
          <SectionSummaryTitle>Your Profile Links</SectionSummaryTitle>
          <SectionSummaryDescription>
            Link to your social media accounts and your website.
          </SectionSummaryDescription>
        </SectionSummary>
        <SectionDetails>
          <LinkedIn url={linkedinUrl} onUpdate={v => setLinks({ ...links, linkedin: v })} />
          <Twitter url={twitterUrl} onUpdate={v => setLinks({ ...links, twitter: v })} />
        </SectionDetails>
      </Section>
    </>
  );
}

SocialLinks.propTypes = {
  linkedinUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  onUpdate: PropTypes.func,
};

SocialLinks.defaultProps = {
  linkedinUrl: null,
  twitterUrl: null,
  onUpdate: () => null,
};
